import React, { useState } from "react";
import styles from "./EditPrice.module.scss";
import { Button, ButtonVariant } from "@src/components/button/Button";
import helperStyles from "@src/components/helpers.module.scss";
import Checkbox from "@src/components/vGrid/Checkbox";

interface TEditPriceModalProps {
	cancel?: () => void;
	onConfirm?: (dontShowAgain: boolean) => void;
}

const EditPriceModal: React.FC<TEditPriceModalProps> = ({ onConfirm, cancel }) => {
	const [dontShowAgain, setDontShowAgain] = useState(false);

	const handleCheckboxChange = () => {
		setDontShowAgain(!dontShowAgain);
	};

	return (
		<div className={styles.root}>
			<div className={styles.message}>
				Some of your price changes exceed a 30% difference compared to current prices.
				<br /> <br />
				Are you sure you want to continue?
			</div>

			<div className={styles.dontShow}>
				<Checkbox isChecked={dontShowAgain} controlSize="sm" onChange={handleCheckboxChange} />
				Don’t show this again for the next 60 minutes.
			</div>

			<div className={styles.actions}>
				<Button onClick={cancel} variant={ButtonVariant.Secondary}>
					<div className={helperStyles.centerWithGap}>Cancel</div>
				</Button>
				<Button onClick={() => onConfirm?.(dontShowAgain)} variant={ButtonVariant.Secondary}>
					<div className={helperStyles.centerWithGap}>Confirm</div>
				</Button>
			</div>
		</div>
	);
};

export default EditPriceModal;
